// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3onTh","head":"ProcedureTableInfo_head__2hunr"};